<template>
  <div class="apply-container">
    <el-card>
      <template #header>
        <span>达人申请</span>
      </template>

      <el-form :model="form" :rules="rules" ref="applyForm" label-width="120px">
        <el-form-item label="入驻类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择入驻类型">
            <el-option label="机构/代理" value="机构/代理" />
            <el-option label="个人达人" value="个人达人" />
          </el-select>
        </el-form-item>

        <el-form-item label="微信号" prop="wechat">
          <el-input v-model="form.wechat" placeholder="请输入您的微信号" />
        </el-form-item>

        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入您的手机号">
            <template #append>
              <el-button :disabled="isCounting" @click="getVerificationCode">
                {{ isCounting ? `${countdown}秒后重试` : "获取验证码" }}
              </el-button>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item label="验证码" prop="code">
          <el-input v-model="form.code" placeholder="请输入验证码" />
        </el-form-item>

        <el-form-item label="合作协议" prop="agreement">
          <el-checkbox v-model="form.agreement">
            <span @click="showAgreementDialog = true" style="cursor: pointer; color: #409eff">
              我已阅读并同意以上合作协议
            </span>
          </el-checkbox>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm">提交申请</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>

  <el-dialog v-model="showAgreementDialog" title="合作协议" width="50%">
    <div>
      <p>这里是详细的合作协议内容...</p>
      <el-checkbox v-model="tempAgreement">同意协议</el-checkbox>
    </div>
    <template #footer>
      <!-- <el-button @click="showAgreementDialog = false">取消</el-button> -->
      <el-button type="primary" @click="handleAgreementConfirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref } from "vue";
import { ElMessage } from "element-plus";
// import { Plus } from "@element-plus/icons-vue";
import axios from "axios";

const isCounting = ref(false);
const countdown = ref(60);
const applyForm = ref(null);
const showAgreementDialog = ref(false);
const tempAgreement = ref(false);

const getVerificationCode = () => {
  if (!form.value.phone) {
    ElMessage.warning("请输入手机号");
    return;
  }

  // 这里添加发送验证码的API请求
  axios.post("/admin/submit-verification-code", { phone: form.value.phone });

  isCounting.value = true;
  const timer = setInterval(() => {
    countdown.value--;
    if (countdown.value === 0) {
      clearInterval(timer);
      isCounting.value = false;
      countdown.value = 60;
    }
  }, 1000);
};

const handleAgreementConfirm = () => {
  form.value.agreement = tempAgreement.value;
  showAgreementDialog.value = false;
};

const form = ref({
  type: "",
  phone: "",
  wechat: "",
  reason: "",
  proof: [],
  agreement: false, // 新增协议同意状态
  code: "", // 新增验证码字段
});

const resetForm = () => {
  form.value = {
    name: "",
    phone: "",
    wechat: "",
    reason: "",
    proof: [],
  };
};

const rules = ref({
  name: [
    { required: true, message: "请输入姓名", trigger: "blur" },
    { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" },
  ],
  phone: [
    { required: true, message: "请输入手机号", trigger: "blur" },
    { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号", trigger: "blur" },
  ],
  wechat: [{ required: true, message: "请输入微信号", trigger: "blur" }],
  reason: [
    { required: true, message: "请输入申请理由", trigger: "blur" },
    { min: 10, max: 200, message: "长度在 10 到 200 个字符", trigger: "blur" },
  ],
  agreement: [
    {
      required: true,
      message: "请阅读并同意合作协议",
      trigger: "change",
      validator: (rule, value, callback) => {
        if (value) {
          callback();
        } else {
          callback(new Error("请阅读并同意合作协议"));
        }
      },
    },
  ],
  code: [
    { required: true, message: "请输入验证码", trigger: "blur" },
    { len: 6, message: "验证码长度为6位", trigger: "blur" },
  ],
});

const submitForm = () => {
  applyForm.value.validate((valid) => {
    if (valid) {
      // 表单验证通过，提交表单
      console.log("表单提交数据", form.value);
      // 这里可以添加实际的提交逻辑，比如调用API
      axios
        .post("/admin/submit-form", form.value)
        .then((response) => {
          console.log(response);
          if (response.data.msg == "success") {
            ElMessage.success("申请已提交");
            resetForm();
          } else {
            ElMessage.error("申请提交失败：" + response.data.err);
          }
        })
        .catch((error) => {
          console.log(error);
          // 处理错误响应
          ElMessage.error("申请提交失败");
        });
    } else {
      // 表单验证失败
      ElMessage.error("请正确填写表单");
    }
  });
};
</script>

<style scoped>
.apply-container {
  max-width: 800px;
  margin: 20px auto;
}
</style>
